module.exports = __webpack_public_path__ + "img/cca.8caf5405.png";